// extracted by mini-css-extract-plugin
export default {"timeUnit":"timeUnit__2lHLn","timeValue":"timeValue__rYfw3","timeLabel":"timeLabel__fw9GL","separator":"separator__-1bW6"};